export const playCopy = {
  play_subnav_title: "在线运行",
  play_subnav_config: "TS 配置",
  play_config_language_blurb: "编辑器应该使用哪种语言",
  play_subnav_handbook: "帮助",
  play_subnav_examples: "示例",
  play_subnav_examples_close: "关闭",
  play_subnav_settings: "设置",
  play_settings_tabs_settings: "边栏标签",
  play_downloading_typescript: "正在下载 TypeScript...", // when loading
  play_downloading_version: "版本...", // when loading
  play_toolbar_run: "运行",
  play_toolbar_export: "导出",
  play_toolbar_share: "分享",
  play_sidebar_js: ".JS",
  play_sidebar_dts: ".D.TS",
  play_sidebar_errors: "错误",
  play_sidebar_errors_no_errors: "没有错误",
  play_sidebar_logs: "日志",
  play_sidebar_logs_no_logs: "没有日志",
  play_sidebar_options: "选项",
  play_sidebar_options_restart_required: "需要刷新浏览器",
  play_sidebar_options_disable_ata: "禁用 ATA",
  play_sidebar_options_disable_ata_copy:
    "禁用自动获取类型的导入和引入。",
  play_sidebar_options_disable_save: "禁用键入时保存",
  play_sidebar_options_disable_save_copy:
    "禁止在键入时更改 URL。",
  play_sidebar_plugins: "插件",
  play_sidebar_featured_plugins: "特色插件",
  play_sidebar_plugins_options_external:
    "来自 <a href='https://www.npmjs.com/search?q=keywords:playground-plugin'>npm</a> 的第三方插件",
  play_sidebar_plugins_options_external_warning:
    "警告：插件代码来自第三方。",
  play_sidebar_plugins_options_modules: "自定义 npm 模块",
  play_sidebar_plugins_options_modules_placeholder: "来自 npm 的模块名称。",
  play_sidebar_plugins_plugin_dev: "插件开发",
  play_sidebar_plugins_plugin_dev_option:
    "Connect to <code>localhost:5000</code>",
  play_sidebar_plugins_plugin_dev_copy:
    "在开发模式下自动尝试连接到在线运行插件。 您可以在此处开始 <a href='/dev/playground-plugins/' title='Link to the page about Playground Plugins'>制作插件</a>。",
  play_export_report_issue: "在 TypeScript 上报告 GitHub 问题",
  play_export_tweet_md: "推文链接到在线运行",
  play_export_copy_md: "复制为 Markdown 问题",
  play_export_copy_link: "复制为 Markdown 链接",
  play_export_copy_link_preview: "复制为带预览的 Markdown 链接",
  play_export_tsast: "在 TypeScript AST 查看器中打开",
  play_export_bugworkbench: "在 Bug Workbench 中打开",
  play_export_vscode_dev_play: "在 VSCode TS 在线运行（alpha）中打开",
  play_export_sandbox: "在 CodeSandbox 中打开",
  play_export_stackblitz: "在 StackBlitz 中打开",
  play_export_clipboard: "网址已复制到剪贴板",
  play_esm_mode: "切换到 ESM 模式",
  play_clear_logs: "日志已清除",
  play_run_js: "执行 JavaScript",
  play_run_ts: "执行转译的 TypeScript",
  play_run_js_fail: "执行 JavaScript 失败：",
  play_default_code_sample: `// Welcome to the TypeScript Playground, this is a website
// which gives you a chance to write, share and learn TypeScript.

// You could think of it in three ways:
//
//  - A location to learn TypeScript where nothing can break
//  - A place to experiment with TypeScript syntax, and share the URLs with others
//  - A sandbox to experiment with different compiler features of TypeScript

const anExampleVariable = "Hello World"
console.log(anExampleVariable)

// To learn more about the language, click above in "Examples" or "What's New".
// Otherwise, get started by removing these comments and the world is your playground.
  `,

  play_sidebar_js_title: "JavaScript",
  play_sidebar_js_blurb: "显示转译后的 JS",

  play_sidebar_dts_title: "定义文件",
  play_sidebar_dts_blurb: "显示代码的 .d.ts 输出",

  play_sidebar_err_title: "编译器错误",
  play_sidebar_err_blurb: "完整显示编译器错误",

  play_sidebar_run_title: "在浏览器中运行 JavaScript",
  play_sidebar_run_blurb:
    "显示在编辑器中运行 JavaScript 的输出",

  play_sidebar_plugins_title: "管理在线运行插件",
  play_sidebar_plugins_blurb:
    "处理添加/删除在线运行的第三方扩展",

  play_sidebar_ast_title: "[WIP] AST 查看器",
  play_sidebar_ast_blurb: "检查 TypeScript AST",

  play_sidebar_tools_filter_placeholder: "筛选",
  // Notes:
  // Compiler flag information is all from the tsconfig reference info
}
